import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import objectPath from 'object-path';
import Header from './header/Header';
import SubHeader from './sub-header/SubHeader';
import AsideLeft from './aside/AsideLeft';
import Footer from './footer/Footer';
import HTMLClassService from './HTMLClassService';
import LayoutConfig from './LayoutConfig';
import MenuConfig from './MenuConfig';
import CustomerMenuConfig from './customMenuConfig';
import LayoutInitializer from './LayoutInitializer';
// import Content from './Content';
import { authCurrentUserTypeSelector } from '../../modules/auth/Selectors';
import './assets/Base.scss';
import StaticBar from '../../components/DashboardLayout/StaticBar/StaticBar';
import TopBar from '../../components/DashboardLayout/TopBar/TobBar';
import Content from '../../components/DashboardLayout/Content/Content';
import SmartPhoneWarning from './SmartPhoneWarning/SmartPhoneWarning';
import Cookie from 'js-cookie';
const htmlClassService = new HTMLClassService();

const defaultLang = () => {
  if (Cookie.get('lang') === 'en') {
    return 'ltr';
  } else {
    return 'rlt';
  }
};
function Layout({
  children,
  asideDisplay,
  subheaderDisplay,
  selfLayout,
  layoutConfig,
  contentContainerClasses
}) {
  htmlClassService.setConfig(layoutConfig);
  // scroll to top after location changes
  // window.scrollTo(0, 0);
  // const [currentUserMenu, setCurrentUserMenu] = useState({});

  const userType = useSelector(state => authCurrentUserTypeSelector(state));
  // console.log(userType)
  // useEffect(() => {
  //   let menu;
  //   if (userType[0] == 4) {
  //     menu = CustomerMenuConfig;
  //     console.log(`user is Customer`);
  //     setCurrentUserMenu(menu);
  //   } else if (userType[0] == 0) {
  //     menu = MenuConfig;
  //     console.log(`user is admin`);
  //   }

  //   console.log(currentUserMenu);
  // }, [currentUserMenu]);

  const contentCssClasses = htmlClassService.classes.content.join(' ');

  return selfLayout !== 'blank' ? (
    <LayoutInitializer
      menuConfig={MenuConfig}
      layoutConfig={LayoutConfig}
      htmlClassService={htmlClassService}
    >
      {/* <!-- begin:: Header Mobile --> */}
      {/* <!-- end:: Header Mobile --> */}

      {/* <div className="kt-grid kt-grid--hor kt-grid--root"> */}
      {/* <!-- begin::Body --> */}
      {/* <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"> */}
      {/* <!-- begin:: Aside Left --> */}
      {asideDisplay && (
        <>
          <AsideLeft />
        </>
      )}
      {/* <!-- end:: Aside Left --> */}
      <SmartPhoneWarning />
      <div
        className='body'
        id='kt_wrapper'
        style={
          defaultLang() === 'ltr'
            ? { marginLeft: 'auto', marginRight: 'unset' }
            : { marginLeft: 'unset', marginRight: 'auto' }
        }
      >
        {/* <!-- begin:: Header READY --> */}
        <TopBar />
        {/* <StaticBar />  //removed from here to the darshboard page */}
        <Header />
        {/* <!-- end:: Header --> */}
        {/* <!-- begin:: Content --> */}
        {/* <div
					id="kt_content"
					className={`kt-content ${contentCssClasses} kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor`}
				> */}
        <Content>{children}</Content>
        {/* <!-- begin:: Content Head --> */}
        {/*               {subheaderDisplay && (
                <SubHeader />
              )} */}
        {/* <!-- end:: Content Head --> */}
        {/* <!-- begin:: Content Body --> */}
        {/*               <Content>
         */}{' '}
        {/*               </Content>
         */}{' '}
        {/*<!-- end:: Content Body -->*/}
        {/* </div> */}
        {/* <!-- end:: Content --> */}
        {/* <Footer /> */}
        {/* </div> */}
        {/* </div> */}
        {/* <!-- end:: Body --> */}
      </div>
    </LayoutInitializer>
  ) : (
    // BLANK LAYOUT
    <div className='kt-grid kt-grid--ver kt-grid--root'>
      <Content>{children}</Content>
    </div>
  );
}

const mapStateToProps = ({ builder: { layoutConfig } }) => ({
  layoutConfig,
  selfLayout: objectPath.get(layoutConfig, 'self.layout'),
  asideDisplay: objectPath.get(layoutConfig, 'aside.self.display'),
  subheaderDisplay: objectPath.get(layoutConfig, 'subheader.display'),
  desktopHeaderDisplay: objectPath.get(
    layoutConfig,
    'header.self.fixed.desktop'
  ),
  contentContainerClasses: ''
  // contentContainerClasses: builder.selectors.getClasses(store, {
  //   path: "content_container",
  //   toString: true
  // })
});

export default connect(mapStateToProps)(Layout);
